import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RollerShadesClosedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"roller_shades_closed"}/>
}
